import React from 'react'
import TextField from '@mui/material/TextField'

import { profileInfoFieldSx } from '../constants/profileInfoConstants'

export default function ProfileInfoStyledField(props) {
  return (
    <TextField
      fullWidth
      size="small"
      InputLabelProps={{ shrink: true }}
      sx={profileInfoFieldSx}
      {...props}
    />
  )
}
